import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

var authData = localStorage.getItem('mlmcore-vo-auth-data');
var data = JSON.parse(authData);
var isMembership = false;
if (data) isMembership = (data.bin_network_id === "0" || data.bin_network_id === 0) ? true : false;

function getProfile(params) {
	if (isMembership) {
		return client.get("membership/personal/profile", {
			params: params,
		});
	} else {
		return client.get("binary/personal/profile", {
			params: params,
		});
	}
}

function getProfileMitra(params) {
	return client.get("binary/personal/profile", {
		params: params,
	});
}

function getProfilePramitra(params) {
	return client.get("membership/personal/profile", {
		params: params,
	});
}

function editProfileMitra(params) {
	return client.post("binary/personal/edit-profiles", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function editProfilePramitra(params) {
	return client.post("membership/personal/edit-profile", params, {
		header: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

function changeImageMitra(params) {
	return client.post("binary/personal/edit-profile-image", params, {
		header: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

function changeImagePramitra(params) {
	return client.post("membership/personal/edit-profile-image", params, {
		header: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

function changePasswordMitra(params) {
	return client.post("binary/personal/edit-password", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function changePasswordPramitra(params) {
	return client.post("membership/personal/edit-password", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getBankMitra(params) {
	return client.get("binary/personal/my-bank", {
		params: params,
	});
}

function getBankPramitra(params) {
	return client.get("membership/personal/my-bank", {
		params: params,
	});
}

function getMitraData(params) {
	return client.get("general/get-member-by-id", {
		params: params,
	});
}

function editBankMitra(params) {
	return client.post("binary/personal/edit-my-bank", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function editBankPramitra(params) {
	return client.post("membership/personal/edit-my-bank", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getProfile,
	getProfileMitra,
	getProfilePramitra,
	editProfileMitra,
	editProfilePramitra,
	changeImageMitra,
	changeImagePramitra,
	changePasswordMitra,
	changePasswordPramitra,
	getBankMitra,
	getBankPramitra,
	editBankMitra,
	editBankPramitra,
	getMitraData
};